import { render, staticRenderFns } from "./RecommendedProductsSection.vue?vue&type=template&id=1e03cc9d&scoped=true&"
import script from "./RecommendedProductsSection.vue?vue&type=script&lang=js&"
export * from "./RecommendedProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedProductsSection.vue?vue&type=style&index=0&id=1e03cc9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e03cc9d",
  null
  
)

export default component.exports